import React from 'react';
import Singlemission from './MissionList';

const Missions = () => (
  <div className="mt-5">
    <Singlemission />
  </div>
);
export default Missions;
